import React, {useState, useContext, useEffect,} from "react";
import {GlobalContext} from "../context/GlobalState";
import {css} from "emotion";
import {boxStyles, colors, textSizes} from "../styles/theme";
import SwitchHeader from "../components/SwitchHeader";
import TitleBlock from "../components/TitleBlock";
import GenericButton from "../components/GenericButton";
import auth from "../services/api/auth";
import {withRouter, useLocation} from "react-router-dom";
import {useForm,} from "react-hook-form";
import ErrorMessage from "../components/ErrorMessage";
import queryString from 'querystring';

const UpdatePassword = ({history}) => {
  useEffect(() => {
    document.title = 'Update Password - Spotlight'
  });
  const location = useLocation();
  const parsed = queryString.parse(location.search);
  const token = parsed['?token'];

  if (!token) {
    history.push('/forgot-password')
  }

  const {doLogin} = useContext(GlobalContext);
  const methods = useForm();
  const {register, handleSubmit, errors, setError, clearError} = methods;

  const [isLoading, setLoading] = useState(false);

  const handleResetClick = async ({newPassword, confirmPassword}) => {
    if (newPassword !== confirmPassword) {
      setError('confirmPassword', 'matchError', 'Passwords must match');
      return;
    }

    setLoading(true);
    const resetData = {
      password: newPassword,
      token,
    };

    try {
      const {data} = await auth.updatePasswordAndLogIn(resetData);
      const stateData = {
        userData: {
          id: data.id,
          emailAddress: data.emailAddress,
          firstName: data.firstName,
          lastName: data.lastName,
        },
        defaultWorkspace: data.defaultWorkspace,
        workspaces: data.workspaces,
      };

      doLogin(stateData);
      history.push("/home");
    } catch (error) {
      if (error.response) {
        setError('login', 'badCombo', 'The password reset token is expired or invalid. Please request another token.');
      } else if (error.request) {
        setError('login', 'noConnection', 'You seem to have gotten disconnected. Make sure your internet is connected and try again.');
        console.log(error.request);
      } else {
        setError('login', 'unexpected', 'There was a problem logging into your account. Please reload the page and try again.');
        console.log('Error', error.message);
      }
      setLoading(false);
    }
  };

  return (
    <div className={container}>
      <SwitchHeader/>
      <div className="body">
        <div className="centerBlock">
          <div className="hero">
            <TitleBlock
              title="Enter a new password"
              subtitle="A fresh start will help clear things up."
            />
          </div>
          <form className="form">
            {errors.login && <ErrorMessage>{errors.login.message}</ErrorMessage>}
            <div className="formItem">
              <label>
                <p style={{display: 'inline-block'}}>NEW PASSWORD</p>
                <input
                  name="newPassword"
                  type="password"
                  ref={register({
                    required: {
                      value: true,
                      message: 'Password is required'
                    },
                    minLength: {
                      value: 6,
                      message: 'Password must be at least 6 characters'
                    },
                  })}
                />
              </label>
              {errors.newPassword && <ErrorMessage>{errors.newPassword.message}</ErrorMessage>}
            </div>
            <div className="formItem">
              <label>
                <p style={{display: 'inline-block'}}>CONFIRM PASSWORD</p>
                <input
                  name="confirmPassword"
                  type="password"
                  ref={register({
                    required: {
                      value: true,
                      message: 'Password is required'
                    },
                  })}
                  onChange={() => clearError('matchError')}
                />
              </label>
              {errors.confirmPassword && <ErrorMessage>{errors.confirmPassword.message}</ErrorMessage>}
            </div>
            <div className="buttonSection">
              <div className="button">
                <GenericButton
                  text="Update Password"
                  handleClick={handleSubmit(handleResetClick)}
                  disabled={isLoading}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default withRouter(UpdatePassword);

const container = css`
  display: flex;
  flex-direction: column;

  .body {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
  }

  .centerBlock {
    max-width: 650px;
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
  }

  .hero {
    max-width: 650px;
    width: 100%;
    padding: 40px 0;
  }
  .form {
    width: 90%;
    max-width: 455px;

    .buttonSection {
      display: flex;
      flex: 1;
      justify-content: center;
      padding: 10px;
      margin-top: 24px;

      .button {
        width: 50%;
      }
      button:focus {
        outline: none;
      }
    }
  }
  .formItem {
    padding: 10px;

    label {
      font-size: ${textSizes.normal};
      color: ${colors.placeholderText};

      input {
        color: ${colors.inputTextColor};
        box-sizing: border-box;
        width: 100%;
        background-color: ${colors.inputBackground};
        padding: 10px;
        border: none;
        border-radius: ${boxStyles.borderRadius};
        color: ${colors.inputTextColor};
        font-size: ${textSizes.normal};
        outline: none;
      }
    }
  }

  .passwordInput {
    p {
      bottom: 10px;
      right: 10px;
    }
  }
  
  .forgot-password-link {
    display: inline-block;
    margin-left: 5px;
    color: ${colors.placeholderText};
    text-decoration: none;
    opacity: .7;
    transition-duration: .2s;
    padding: 5px 0;
    
    &:hover {
      opacity: 1;
    }
  }
`;
